<script lang="ts">
	import type { Snippet } from 'svelte';

	const { children }: { children: Snippet } = $props();

	let renderComponent = $state(false);

	function intersectionObserver(node: HTMLDivElement) {
		const observer = new IntersectionObserver((entries) => {
			if (!renderComponent) renderComponent = entries.some((entry) => entry.isIntersecting);
		});
		observer.observe(node as HTMLDivElement);

		return {
			destroy() {
				observer.disconnect();
			},
		};
	}
</script>

{#if renderComponent}
	{@render children()}
{:else}
	<div use:intersectionObserver></div>
{/if}
